import {
    CatalogsState,
    CountrySelectorState,
    CreditoRealBankApplication,
    GlobalValidationsState,
    LocationState,
    LoginState,
    ProfileState,
    State,
    TurboCashBankApplication,
    UIState,
    UTMDataState
} from '../types/mx/reducers';
import {globalValidationInit} from '../constants/GlobalValidationInit';
import {catalogInit} from '../constants/CatalogInit';
import {utmInit} from '../constants/UTMInit';
import {creditoRealInit} from '../constants/CreditoRealInit';
import {uIInit} from '../constants/UIInit';
import {COUNTRY_INITIALS} from '../../common/constants/AppConstants';
import {TurboCashInit} from '../constants/TurboCashInit';

export const defaultState: State = {
    login: {
        pathToRedirect: null
    } as LoginState,
    profile: {
        userId: '',
        email: '',
        firstName: '',
        lastName: '',
        roles: [],
        accessToken: '',
        refreshToken: ''
    } as ProfileState,
    location: {
        geo: '',
        ip: ''
    } as LocationState,
    countrySelector: {
        countrySelected: COUNTRY_INITIALS.MEXICO
    } as CountrySelectorState,
    globalValidations: globalValidationInit as GlobalValidationsState,
    catalogs: catalogInit as CatalogsState,
    creditoReal: creditoRealInit as CreditoRealBankApplication,
    turboCash: TurboCashInit as TurboCashBankApplication,
    ui: uIInit as UIState,
    utmData: utmInit as UTMDataState
};